import { render, staticRenderFns } from "./Egg.vue?vue&type=template&id=d96ff9d6&scoped=true"
import script from "./Egg.vue?vue&type=script&lang=js"
export * from "./Egg.vue?vue&type=script&lang=js"
import style0 from "./Egg.vue?vue&type=style&index=0&id=d96ff9d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d96ff9d6",
  null
  
)

export default component.exports